
import React, { useState, onChange, useEffect } from 'react';
import { Card, Button, Col, Row, Container, CardImg } from 'react-bootstrap';




import "./Blogs.css";
import write from "../../img/write.svg";
import strong from "../../img/strong.jpg";

import arroww from "../../img/arrow.svg";
import { myFirestore } from '../../services/firebase'

import { Link } from 'react-router-dom'
import SearchField from "react-search-field";

function BlogsCard(props) {
  return (

    // common multiple cards
    <Col lg={3}>
      <Link to={{
        pathname: '/readmore/' + props.blog.title,

        state: {
          blog: props.blog
        }
      }}>
        <Card className='card-blogs'>



          <Card.Body>
            <Card.Header style={{ backgroundColor: "transparent", color: "Black", textAlign: "left" }}>{props.blog.title}</Card.Header>
            <br />
            <CardImg src={props.blog.imageUrl} className='card-blogs-img'>

            </CardImg>


          </Card.Body>

        </Card>
      </Link>
    </Col>


  );
}





// 
function Blogs(props) {

  const [blogsList, setblogsList] = useState([])

  const readBlogs = () => {
    myFirestore.collection('blogs').get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " => ", doc.data());
          setblogsList(blogsList => [...blogsList, doc.data()])

        });
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);

      });
  }
  useEffect(() => {
    readBlogs()
  }, []);


  return (
    <>

      <Row style={{ margin: '1rem', marginBottom: '0' }} className='justify-content-center'>

        <SearchField
          placeholder="Search..."
          onChange={onChange}
          searchText=""
          classNames="test-class"

        />


      </Row>

      <Row className='justify-content-center' style={{ margin: '1rem' }}>

        {/* <Col sm={12} md={6} className="col-right align-items-start">
          <img src={ContentImg} style={{ width: "40%" ,height:'50%'}}
          />
        </Col> */}



        <h4>Share your story with us, Write what you feel! </h4>
        {/* <Button variant="success">Hover me to see</Button> */}
        <Button href='/writepostBtn' className="hover-btn" style={{

        }}> <img src={write} alt="" style={{}} className='btn-img' />
            Write Here
          </Button>





      </Row>
      {blogsList && <BSection blogsList={blogsList} {...props} />}
    </>


  );
}


export const BSection = (props) => (

  <Container fluid style={{ marginTop: '3rem' }}>



    <Card style={{ marginTop: '1rem', height: '17em' }}>
      <Card.Link style={{ color: "black" }}>

        <Row lg={2} xs={1}>

          <Col lg={5} >
            <Card.Img src={strong} alt="Card image" style={{ height: '17em' }} />
          </Col>
          <Col lg={7}>
            <div className="padding-cardtexts">

              <Card.Title style={{ fontFamily: "bold" }} ><h4>STAY STRONG! HERE’S HOW TO STAY MOTIVATED</h4></Card.Title>
              <Card.Text style={{ fontFamily: "italic" }}>
                It happens gradually and almost goes unnoticed. You’re not getting much done as you
                did before and you don’t feel like working as hard as you used to.
            </Card.Text>
              <Button  className="Read-more" style={{ border: "white" }}>
                Read More
              <img src={arroww} style={{ padding: "0.3rem", width: '25px', color: 'blue' }} alt='' />
              </Button>

            </div>

          </Col>
        </Row>
      </Card.Link>
    </Card>
    <Row
      lg="3"
      sm="3"
      xs="3"
      className={'justify-content-center text-center'}
      style={{ padding: "0.5rem", marginTop: '6rem' }}
    >

      <Col lg="1">
        <hr />
      </Col>
      <Col lg='2'>
      <h5>Featured Blogs</h5>
      </Col>
      <Col lg="1">
        <hr />
      </Col>
    </Row>
    

    <Blogslist blogsList={props.blogsList} {...props}/>


  </Container >

);
export const Blogslist = (props) => (
  <Container fluid style={{ marginTop: '3rem' }}>
    

    <Row style={{ margin: '2rem' }}>
      {props.blogsList.map((blog) => (
        <BlogsCard
          blog={blog}
          
        />

      ))
      }
      {/* <BlogsCard
        title="Be with good one's."
        src={proto}

      />
      <BlogsCard
        title="Motivation you need "
        src={motivate}

      />
      <BlogsCard
        title="Anxious, No More "
        src={strong}

      />

    <BlogsCard
        title="Self improvement, Self care"
        src={proto}

      /> */}




    </Row>
  </Container>

);

export default Blogs;







